(function () {
  function getMainAddToCartForm() {
    const productFormComponent = document.querySelector(
      "product-form.wt-product__add-to-cart",
    );
    return (
      productFormComponent?.querySelector(
        'form[data-type="add-to-cart-form"]',
      ) || document.querySelector('product-form form[action*="/cart/add"]')
    );
  }

  function getHeaderCartCount() {
    const headerCart = document.getElementById("cart-icon-bubble");
    if (!headerCart) return null;
    const counter = headerCart.querySelector(".wt-header__panel__counter");
    if (!counter) return 0;
    const n = parseInt(counter.textContent.trim(), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function updateHeaderCartCount(itemCount) {
    if (typeof window.updateHeaderCartCount === "function") {
      window.updateHeaderCartCount(itemCount);
      return;
    }

    const headerCart = document.getElementById("cart-icon-bubble");
    if (!headerCart || itemCount == null) return;

    let counter = headerCart.querySelector(".wt-header__panel__counter");

    if (itemCount > 0) {
      if (!counter) {
        counter = document.createElement("span");
        counter.className = "wt-header__panel__counter";
        const label = headerCart.querySelector(".wt-header__panel__label");
        if (label) {
          headerCart.insertBefore(counter, label);
        } else {
          headerCart.appendChild(counter);
        }
      }
      counter.textContent = String(itemCount);
    } else if (counter) {
      counter.remove();
    }
  }

  function updateStickyCartBadge(itemCount) {
    const cartBadge = document.getElementById("StickyCartBadge");
    const cartCircle = document.getElementById("StickyCartCircle");
    if (!cartBadge || itemCount == null) return;

    if (itemCount > 0) {
      cartBadge.textContent = String(itemCount);
      cartBadge.classList.add("is-active");
      cartCircle?.classList.add("is-success");
    } else {
      cartBadge.textContent = "0";
      cartBadge.classList.remove("is-active");
      cartCircle?.classList.remove("is-success");
    }
  }

  function syncStickyFromHeader() {
    const headerCount = getHeaderCartCount();
    if (headerCount != null) {
      updateStickyCartBadge(headerCount);
    }
  }

  function syncCartCounts(itemCount) {
    if (itemCount == null) {
      fetch((window.Shopify?.routes?.root || "/") + "cart.js")
        .then((res) => res.json())
        .then((cart) => {
          const count = cart.item_count || 0;
          updateStickyCartBadge(count);
          updateHeaderCartCount(count);
        })
        .catch(() => {
          syncStickyFromHeader();
        });
      return;
    }
    updateStickyCartBadge(itemCount);
    updateHeaderCartCount(itemCount);
  }

  function clearStickyLoadingState() {
    const stickyButton = document.getElementById("StickyProxyButton");
    const cartCircle = document.getElementById("StickyCartCircle");

    stickyButton?.classList.remove("is-loading");
    if (stickyButton) stickyButton.disabled = false;
    cartCircle?.classList.remove("is-loading");
  }

  document.addEventListener("DOMContentLoaded", function () {
    const cartCircle = document.getElementById("StickyCartCircle");
    if (!document.getElementById("StickyCartBadge")) return;

    // Initial sync: prefer live cart.js, fall back to header badge
    syncCartCounts(null);

    if (
      typeof subscribe === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        clearStickyLoadingState();
        if (event?.cartData?.item_count != null) {
          syncCartCounts(event.cartData.item_count);
        } else {
          // Header section often updates first — mirror it, then confirm via cart.js
          syncStickyFromHeader();
          window.setTimeout(() => syncCartCounts(null), 150);
        }
      });
    }

    document.addEventListener("cart:updated", () => syncCartCounts(null));
    document.addEventListener("lumineve:cart-updated", (event) => {
      clearStickyLoadingState();
      const itemCount = event?.detail?.item_count;
      syncCartCounts(itemCount != null ? itemCount : null);
    });

    // Keep sticky in lockstep when Shopify re-renders the header cart bubble
    const headerCart = document.getElementById("cart-icon-bubble");
    if (headerCart && typeof MutationObserver !== "undefined") {
      const headerObserver = new MutationObserver(() => {
        syncStickyFromHeader();
      });
      headerObserver.observe(headerCart, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    document.addEventListener("click", function (e) {
      const stickyButton = e.target.closest("#StickyProxyButton");
      if (!stickyButton) return;

      e.preventDefault();

      const form = getMainAddToCartForm();
      const realBtn = form?.querySelector('button[name="add"]');
      if (!form || !realBtn || realBtn.disabled) return;

      const scrollY = window.scrollY;

      cartCircle?.classList.remove("is-success");
      cartCircle?.classList.add("is-loading");
      stickyButton.disabled = true;
      stickyButton.classList.add("is-loading");

      if (typeof form.requestSubmit === "function") {
        form.requestSubmit(realBtn);
      } else {
        realBtn.click();
      }

      window.setTimeout(() => {
        window.scrollTo(0, scrollY);
      }, 60);

      // Re-sync after add completes (header section + cart.js)
      window.setTimeout(() => {
        clearStickyLoadingState();
        syncStickyFromHeader();
        syncCartCounts(null);
      }, 900);
    });

    if (cartCircle) {
      cartCircle.addEventListener("click", function (e) {
        e.preventDefault();
        document.getElementById("cart-icon-bubble")?.click();
      });
    }
  });
})();
